import {h} from 'preact';
import style from './style.css';

const ParagraphSeperator = () => (<hr class={style['paragraph-seperator']} />);

export default ParagraphSeperator;
